<div class="loginBodyContainer" style="background: #f6f6f6;">
    <div class="LoginHeadderContainer">
      <div class="LoginERPTitle">
        <p class="LoginERPTitleParagraph">
          {{ 'HOME.TITLE' | translate }}
        <i class="material-icons">cloud_queue</i>
        </p>

        <div class="LoginERPTitleParagraphRight">
          <div class="LoginERPTitleHalf" style="width: 70%;">
            <p class="TitleDocStatus" *ngIf="DocumentStatus != null && DocumentStatus.length > 0;">{{DocumentStatus}}</p>
            <p class="TitleDueDate" *ngIf="DocumentDueDate != null && DocumentDueDate.length > 0;">{{'DueDate' | translate}} {{DocumentDueDate}}</p>
          </div>
          <div class="LoginERPTitleHalf" style="width: 30%;">
            <p class="TitlePriceP">
              <span class="TitleCurrencySpan" *ngIf="DocumentCurrency != null && DocumentCurrency.length > 0;">{{DocumentCurrency}}</span>
              <span class="DocumentPriceSpan" *ngIf="DocumentPrice != null && DocumentPrice.length > 0;">{{DocumentPrice}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    
  <router-outlet></router-outlet>
  </div>
  